import React, { Component } from "react";
import { connect } from "react-redux";
import { getNotes, postNote, putNote, deleteNote } from "../les-tabs-ducks/Notes.ducks";
import _ from "lodash";
import moment from "moment";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import { withTranslation } from 'react-i18next';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titre: "",
      description: "",
      showForm: false,
      editingNote: null,
    };
  }

  componentDidMount() {
    let tok = localStorage.getItem("token");
    let id = window.location.pathname.match(/\d+/g)[0];
    this.props.getNotes(tok, id);
  }

  handleAdd = () => {
    this.setState({ showForm: true, editingNote: null, titre: "", description: "" });
  };

  handleEdit = (note) => {
    this.setState({
      showForm: true,
      editingNote: note,
      titre: note.titre,
      description: note.description,
    });
  };

  handleCancel = () => {
    this.setState({ showForm: false, editingNote: null, titre: "", description: "" });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let tok = localStorage.getItem("token");
    let idEnfant = window.location.pathname.match(/\d+/g)[0];
    const data = {
      titre: this.state.titre,
      description: this.state.description,
      dateTime: moment().format(),
    };

    if (this.state.editingNote) {
      this.props.putNote(tok, this.state.editingNote.id, data, idEnfant);
    } else {
      this.props.postNote(tok, idEnfant, data);
    }
    this.setState({ showForm: false, editingNote: null, titre: "", description: "" });
  };

  handleDelete = (idNote) => {
    if (window.confirm(this.props.t('fiche_enfant.confirm_delete_note'))) {
      let tok = localStorage.getItem("token");
      let idEnfant = window.location.pathname.match(/\d+/g)[0];
      this.props.deleteNote(tok, idNote, idEnfant);
    }
  };

  render() {
    const { notes, loading } = this.props;
    const sortedNotes = !_.isEmpty(notes)
      ? [...notes].sort((a, b) => moment(b.dateTime).diff(a.dateTime))
      : [];

    return (
      <div
        className="tab-pane show active"
        id="notes-pane"
        role="tabpanel"
        aria-labelledby="notes-tab"
      >
        <div className="content p-0">
          <section className="content-section border-0 mb-0">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 style={{ margin: 0 }}>{this.props.t('fiche_enfant.notes.title')}</h2>
              {!this.state.showForm && (
                <button
                  className="btn btn-gradient"
                  onClick={this.handleAdd}
                  style={{ borderRadius: "20px", padding: "6px 20px" }}
                >
                  {this.props.t('fiche_enfant.notes.add')}
                </button>
              )}
            </div>

            {this.state.showForm && (
              <div
                style={{
                  background: "#f8f9fa",
                  borderRadius: "8px",
                  padding: "20px",
                  marginBottom: "20px",
                  border: "1px solid #e0e0e0",
                }}
              >
                <form onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <label style={{ fontWeight: "600", color: "#333" }}>{this.props.t('common.title_label')}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.titre}
                      onChange={(e) => this.setState({ titre: e.target.value })}
                      placeholder={this.props.t('fiche_enfant.notes.title_placeholder')}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label style={{ fontWeight: "600", color: "#333" }}>{this.props.t('common.description_label')}</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      value={this.state.description}
                      onChange={(e) => this.setState({ description: e.target.value })}
                      placeholder={this.props.t('fiche_enfant.notes.content_placeholder')}
                      required
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary mr-2"
                      onClick={this.handleCancel}
                      style={{ borderRadius: "20px", padding: "6px 20px" }}
                    >
                      {this.props.t('common.cancel')}
                    </button>
                    <button
                      type="submit"
                      className="btn btn-gradient"
                      disabled={!this.state.titre.trim() || !this.state.description.trim()}
                      style={{ borderRadius: "20px", padding: "6px 20px" }}
                    >
                      {this.state.editingNote ? this.props.t('common.modify') : this.props.t('common.save')}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {loading ? (
              <div className="content p-0">
                <DotLoader
                  size={100}
                  color={"#ff7d26"}
                  css={override}
                  loading={true}
                />
              </div>
            ) : _.isEmpty(sortedNotes) ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px",
                  color: "#999",
                }}
              >
                <p>{this.props.t('fiche_enfant.notes.empty')}</p>
              </div>
            ) : (
              <div>
                {sortedNotes.map((note) => (
                  <div
                    key={note.id}
                    style={{
                      background: "#fff",
                      borderRadius: "8px",
                      padding: "16px",
                      marginBottom: "12px",
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-start">
                      <div style={{ flex: 1 }}>
                        <h5 style={{ marginBottom: "4px", color: "#333", fontWeight: "600" }}>
                          {note.titre}
                        </h5>
                        <small style={{ color: "#999" }}>
                          {moment(note.dateTime).format("DD/MM/YYYY à HH:mm")}
                          {note.noteur && (
                            <span>
                              {" — "}
                              {note.noteur.prenom} {note.noteur.nom}
                            </span>
                          )}
                        </small>
                        <p style={{ marginTop: "8px", marginBottom: 0, color: "#555", whiteSpace: "pre-wrap" }}>
                          {note.description}
                        </p>
                      </div>
                      <div className="d-flex" style={{ marginLeft: "12px" }}>
                        <button
                          className="btn btn-sm btn-outline-primary mr-1"
                          onClick={() => this.handleEdit(note)}
                          title={this.props.t('common.modify')}
                          style={{ borderRadius: "50%", width: "32px", height: "32px", padding: 0 }}
                        >
                          <i className="fas fa-pen" style={{ fontSize: "12px" }}></i>
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => this.handleDelete(note.id)}
                          title={this.props.t('common.delete')}
                          style={{ borderRadius: "50%", width: "32px", height: "32px", padding: 0 }}
                        >
                          <i className="fas fa-trash" style={{ fontSize: "12px" }}></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  notes: state.ficheEnfant.Notes.data,
  loading: state.ficheEnfant.Notes.loading,
});

export default connect(mapStateToProps, {
getNotes,
  postNote,
  putNote,
  deleteNote,
})(withTranslation()(Notes));
